import NewsletterForm from './components/NewsletterForm.vue';
import ShareComponent from './components/ShareComponent.vue';
import SlidingDropdown from './components/SlidingDropdown.vue';
import HamburgerButton from './components/HamburgerButton';
import HeaderListSpaceButton from './components/HeaderListSpaceButton';
import LazyBackground from './components/LazyBackground';
import { loader as loadComponents } from './components';
import './modules/Modals';

/**
 * Provide frontend specific components
 */
loadComponents({
    SlidingDropdown,
    NewsletterForm,
    share: ShareComponent,
    HamburgerButton,
    HeaderListSpaceButton,
    LazyBackground,
});

/**
 * Page Loader
 * If we haven't loaded a specific page we'll fake the promise
 * @type {array}
 */
let LoadedPages = [];

// Space page
if (Page.is('spaceshow')) {
    LoadedPages.push(import('./pages/frontend/Space'));
}

// Space booking page
if (Page.is('spacebook')) {
    LoadedPages.push(import('./pages/frontend/Booking'));
}

if (Page.is('search')) {
    LoadedPages.push(import('./pages/frontend/Search'));
}

if (Page.is('leave-reviewbooking')) {
    LoadedPages.push(import('./pages/frontend/LeaveReview'));
}

if (
    Page.in([
        'auth',
        'authforgotten-password',
        'authforgotten-passwordreset',
    ])
) {
    LoadedPages.push(import('./pages/frontend/Auth'));
}

if (
    Page.in([
        'payment-authorizationstripebiller-migration-flow',
        'payment-authorizationbraintreebiller-migration-flow',
    ])
) {
	LoadedPages.push(import('./pages/account/PaymentAuthorizationFlow'));
}

if (Page.in(['auto-payset-up', 'auto-payregister', 'auto-payauth', 'auto-payterms'])) {
    LoadedPages.push(import('./pages/frontend/AutoPay'));
}

if (Page.is('auto-payregister-discount')) {
    LoadedPages.push(import('./pages/frontend/auto-pay/RegisterDiscountPage'));
}

// Whoever did this is just lazy. Please stop.
$(document).on('click', '[data-toggle-footer]', () => {
    $('.hidden-footer').toggleClass('open');
});

export default LoadedPages;
